import { forwardRef, useState, useImperativeHandle } from "react";
import React from "react";
import Knapsack_Item from "./Knapsack_Item";

var itemSource = [];
var bagSize1 = 0;
const Result = forwardRef((props, ref) => {

	//https://stackoverflow.com/questions/64273786/is-there-a-way-to-call-a-childs-function-from-parent-in-react
	const [itemGUI, setItemGUI] = useState([]); //for GUI, not programatically accessible

	const [txt, setTxt] = useState(""); //data from knapsack
	const [txt2, setTxt2] = useState("");

	useImperativeHandle(ref, () => ({
		createResult_optimal(items, t, bagSize) {
			bagSize1 = bagSize;
			itemSource = items;
			mapItemToGUI(items);
			setTxt(t);
			createResult_custom();
		},
	}));

	const mapItemToGUI = (items1) => {
		setItemGUI([]);
		setItem(items1);
	};

	const checkBoxHandle = (id, checked) => {
		itemSource[id].chosen = checked;
		createResult_custom();
		setItem(itemSource);
	};

	const setItem = (itemSource) => {
		//https://sentry.io/answers/unique-key-prop/
		var output = itemSource.map((item) => (
			<Knapsack_Item
			key={item.id}
				id={item.id}
				name={item.name}
				weight={item.weight}
				value={item.value}
				chosen={item.chosen}
				checkhandle={checkBoxHandle}
			/> 
		));
		setItemGUI(output);
	}

	function createResult_custom() {
		var output = "Selected Items: ";
		var s1 = "";
		var v = 0;
		var w = 0;
		for (var i = 0; i < itemSource.length; i++) {
			if (itemSource[i].chosen) {
				if (s1 != "") {
					s1 += ",";
				}
				s1 += itemSource[i].name;
				v += itemSource[i].value;
				w += itemSource[i].weight;
			}
		}
		var wDiff = w - bagSize1;//bagSize1 - w;
		output += s1;
		output += "\n" + "Size: " + w;
		if(wDiff != 0){ output += " (" + bagSize1; }
		if (wDiff > 0) {
			output += "+" + wDiff + ")";//output += " (+" + wDiff + ")";
		} else if (wDiff < 0) {
			output += wDiff + ")";//output += " (" + wDiff + ")";
		}
		output += "\n" + "Value: " + v;
		setTxt2(output);
	}

	function header1() {
		if (txt != "") {
			return (
				<div>
					<hr />
					<h2>Suggested List</h2>
				</div>
			);
		}
	}

	function header2() {
		if (txt != "") {
			return (
				<div>
					<hr />
					<h2>My List</h2>
					<div style={{ marginTop: "1em" }} />
				</div>
			);
		}
	}
	
	return (
		<div>
			{header1()}
			<div style={{ whiteSpace: "pre-line" }}>{txt}</div>
			<br />
			{header2()}
			<ul
				role="list"
				className="todo-list stack-large stack-exception"
				aria-labelledby="list-heading"
				style={{ paddingLeft: "1em" }}
			>
				{itemGUI}
			</ul>
			<div style={{ marginTop: "2em" }} />
			<div style={{ whiteSpace: "pre-line" }}>{txt2}</div>
			<div style={{ marginTop: "1em" }} />
			{/* <center><label style={{ fontSize: 12 , color: '#CCCCCC'}}>Coded by Pujana P</label></center> */}
		</div>
	);
});

export default Result;
